import React from "react";
import "../nav/Navigation.css";
import {getPhotoDate, getTime} from "../util/Util";

interface Props {
  date: Date
}

function DateTime(props: Props) {
    return (
        <div>
          <div style={{float: "right"}}>
            <small className={"ml-2 d-inline-block"}>
              <div className={"d-inline-block"}>{getPhotoDate(props.date)} - {getTime(props.date)}</div>
            </small>
          </div>
        </div>
    )
}

export default DateTime;
